import CompanyDocumentViewComponent from "../components/CompanyDocumentView";
import useCompanyDocument from "../hooks/useCompanyDocument";

const CompanyDocumentView = (props) => {
  const useCompanyDocumentProps = useCompanyDocument(props);
  return <CompanyDocumentViewComponent {...useCompanyDocumentProps} />;
};

export default CompanyDocumentView;
